import { Input as UiInput } from "@rumbledirect/ui";
import { QuestionCommentModel } from "survey-core";

export const TextareaQuestion = (props: { question: QuestionCommentModel }) => {
  return (
    <UiInput.TextArea
      styles={{
        root: {
          fontWeight: 500,
          height: props.question.rows === undefined ? "120px" : undefined,
        },
      }}
      id={props.question.inputId}
      disabled={props.question.isDisabledAttr}
      readOnly={props.question.isReadOnlyAttr}
      value={props.question.value}
      style={props.question.inputStyle}
      maxLength={props.question.getMaxLength()}
      showCount={props.question.getPropertyValue("showCount")}
      autoComplete={props.question.autocomplete}
      placeholder={props.question.locPlaceholder.getLocaleText("")}
      rows={props.question.rows}
      autoSize={
        props.question.autoGrow
          ? {
              minRows: props.question.rows,
            }
          : undefined
      }
      onBlur={(e) => props.question.textAreaModel.onTextAreaBlur(e)}
      onFocus={(e) => props.question.textAreaModel.onTextAreaFocus(e)}
      onChange={(e) => props.question.textAreaModel.onTextAreaChange(e)}
      onClick={props.question.readOnlyBlocker}
      onPointerDown={props.question.readOnlyBlocker}
      onCompositionUpdate={(event) =>
        props.question.onCompositionUpdate(event.nativeEvent)
      }
      aria-required={props.question.a11y_input_ariaRequired}
      aria-label={props.question.a11y_input_ariaLabel}
      aria-labelledby={props.question.a11y_input_ariaLabelledBy}
      aria-describedby={props.question.a11y_input_ariaDescribedBy}
      aria-invalid={props.question.a11y_input_ariaInvalid}
      aria-errormessage={props.question.a11y_input_ariaErrormessage}
    />
  );
};
